import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  SubHeaderStyled,
  BodyStyled,
  ButtonWrapperStyled,
} from './styles/ProcessingStyled';
import { ReactComponent as ErrorIcon } from '../../../../images/ui/error-big.svg';

const Error = ({ buttonHandler }) => {
  return (
    <ContainerStyled>
      <HeaderStyled>Lo sentimos!</HeaderStyled>
      <SubHeaderStyled />
      <ErrorIcon />
      <BodyStyled>
        <p>Algo falló, no pudimos procesar tu solicitud</p>
        <p>Por favor reintenta nuevamente</p>
      </BodyStyled>
      <ButtonWrapperStyled>
        <Button
          color="bubbleGum"
          width="300px"
          maxWidth="300px"
          click={buttonHandler}
        >
          REINTENTAR
        </Button>
      </ButtonWrapperStyled>
    </ContainerStyled>
  );
};

Error.propTypes = {
  buttonHandler: PropTypes.func.isRequired,
};

export default Error;
